__turbopack_context__.v({
  "link": "OnlineLocation-module-scss-module__ux1OlW__link",
  "onlineLinkIcon": "OnlineLocation-module-scss-module__ux1OlW__onlineLinkIcon",
  "onlineLocation": "OnlineLocation-module-scss-module__ux1OlW__onlineLocation",
  "text": "OnlineLocation-module-scss-module__ux1OlW__text",
});
